import React, { useContext, useEffect, useState } from 'react';
import { Redirect, Route, useHistory, withRouter } from 'react-router-dom';
import { getLocalAuthStorage } from 'utils/localStorage';
import { AuthContext } from 'context/AuthContext';
import { FiltersContext } from 'context/GlobalFiltersContext';
import { usePermissions } from 'hooks/usePermission';
import jwt from 'jwt-decode';
import { useCookies } from 'react-cookie';
import { Loading } from 'components';

import { getPageAction } from './routePermissionsMap'; // ⬅ novo import

// Remover quando liberar para toda empresa Universal (ID 7014)
// Usuários permitidos: lucas.universal, Janieri, VOMENEZES, WJESUS, testelkp.universal
import { TEMP_DASHBOARD_UNIVERSAL_ALLOWED_USERS } from '../constants/tempDashboardUniversalUsers';

//import { CustomerPortal } from 'pages/CustomerPortal';
const CustomerPortal = React.lazy(() => import('pages/CustomerPortal'));
const PrivateRoute = ({ path, Component, page, ...rest }) => {
  const { permissionContext } = usePermissions();
  const { push } = useHistory();
  const { setAuthContext } = useContext(AuthContext);
  const authStorage = getLocalAuthStorage();
  const { headerFiltersContext } = useContext(FiltersContext);
  const { headerFilters } = headerFiltersContext;
  const [cookie] = useCookies();
  const companyId = headerFilters?.companies?.id;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (cookie?.wobaRoute?.startsWith('/chamado-woba/')) {
      push('/logout');
      return;
    }
    if (!authStorage || !authStorage.isAuthenticated || !authStorage.token) {
      setAuthContext({
        statusCode: false,
        isAuthenticated: false,
        token: null,
        refreshToken: null,
        expiresIn: null,
        user: {
          name: null,
          permissionType: null,
        },
      });

      push('/login');
    }
    setLoading(false);
  }, [authStorage, setAuthContext, cookie?.wobaRoute, push]);

  if (loading) {
    return <Loading />;
  }

  if (!authStorage || !authStorage.isAuthenticated || !authStorage.token) {
    return null;
  } else {
    const { token } = getLocalAuthStorage();
    const { utyp } = jwt(token);
    const tipoUsuario = JSON.parse(utyp);
    if (tipoUsuario === 1) {
      if (path === '/portal-do-cliente') {
        return <Redirect to={'/dashboard'} />;
      }
      return <Route path={path} render={props => <Component {...props} companyId={companyId} />} {...rest} />;
    } else if (
      path === '/dashboard' /*cookie?.companies?.id === '7014' ||*/ &&
      TEMP_DASHBOARD_UNIVERSAL_ALLOWED_USERS.includes(String(authStorage?.user?.id))
    ) {
      // TODO GAFA-63: Usuários de teste devem acessar dashboard universal como home
      return <Redirect to="/dashboard-universal" />;
    } else if (
      path === '/dashboard-universal' &&
      Number(cookie?.companies?.id) !== 4157 &&
      !TEMP_DASHBOARD_UNIVERSAL_ALLOWED_USERS.includes(String(authStorage?.user?.id))
    ) {
      return <Redirect to="/dashboard" />;
    } else if ((page === 'config' || page === 'cadastros') && tipoUsuario === 2) {
      return <Route path={path} render={props => <Component {...props} companyId={companyId} />} {...rest} />;
    } else if (tipoUsuario === 4) {
      if (path !== '/portal-do-cliente') {
        return <Redirect to={'/portal-do-cliente'} />;
      }
      return (
        <Route
          path={'/portal-do-cliente'}
          render={props => <CustomerPortal {...props} companyId={companyId} />}
          {...rest}
        />
      );
    } else if (permissionContext[page]) {
      return <Route path={path} render={props => <Component {...props} companyId={companyId} />} {...rest} />;
    } else {
      push('/permission-error');
      return null;
    }
  }

  // ---------------------------
  // 🔐 NOVA LÓGICA DE PERMISSÕES (granular e compatível)
  // ---------------------------
  const perm = permissionContext[page];

  const hasAccess = (() => {
    if (!perm) return false;

    // 🔹 Telas antigas: boolean → continua igual
    if (typeof perm === 'boolean') return perm;

    // 🔹 Telas novas: objeto → permissões por ação
    if (typeof perm === 'object') {
      const action = getPageAction(page, path);
      if (!action) return false;
      return perm[action] === true;
    }

    return false;
  })();

  if (!hasAccess) {
    push('/permission-error');
    return null;
  }

  return <Route path={path} render={props => <Component {...props} companyId={companyId} />} {...rest} />;
};

export default withRouter(PrivateRoute);
